/*
 * File: deliveryAddressZipCodeFilter.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 30 Dec 2021 12:18:36 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterZipCode } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

/* ****************** Interfaces ****************** */
interface Props {
  isDisabled?: boolean;
}

export const DeliveryAddressZipCodeFilter = ({ isDisabled }: Props): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterZipCode(ev.target.value));
  }, 500);

  useEffect(() => {
    return (): void => {
      dispatch(setFilterZipCode(undefined));
    };
  }, [dispatch]);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput placeholder="Zip Code" width={150} disabled={isDisabled} onChange={handleInputChange} />
    </Space>
  );
};
